import { render } from "./ClaimEventDropdown.vue?vue&type=template&id=c5a7f4a2"
import script from "./ClaimEventDropdown.vue?vue&type=script&lang=js"
export * from "./ClaimEventDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/src/client/.yarn/__virtual__/vue-loader-virtual-e12e5a5897/0/cache/vue-loader-npm-17.0.1-f552b82805-b10a7b05ba.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__